<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Le parcours Omega" />
            <ParcoursOMEGA/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import ParcoursOMEGA from './ParcoursOMEGA.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        ParcoursOMEGA,
        FooterComp,
    }
}
</script>